import { render, staticRenderFns } from "./sidestepper.vue?vue&type=template&id=4877728e&scoped=true&"
import script from "./sidestepper.vue?vue&type=script&lang=js&"
export * from "./sidestepper.vue?vue&type=script&lang=js&"
import style0 from "./sidestepper.vue?vue&type=style&index=0&id=4877728e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4877728e",
  null
  
)

export default component.exports